import { BaseModel } from '@Common/Basic/models/base.model';
import { EventApiModel } from '../../../api/events/models/event.api.model';
import { EventResourceTypeEnum } from '../../../api/events/enum/event-resource-type.enum';

export class EventModel extends BaseModel<EventModel, EventApiModel> {

    date?: Date;
    accountId?: number;
    userId?: number;

    resourceId?: number;
    resourceType?: EventResourceTypeEnum;
    action?: string;
    details?: string;


    constructor(apiModel?: EventApiModel) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }


    constructFromApiModel(apiModel: EventApiModel) {
        // ensure date is represented in UTC time
        this.date = new Date(apiModel.date + 'Z');
        this.accountId = apiModel.accountId;
        this.userId = apiModel.userId;
        this.resourceId = apiModel.resourceId;
        this.resourceType = apiModel.resourceType;
        this.action = apiModel.action;
        this.details = apiModel.details;
    }

    // @TODO empty
    constructDefault() {

    }

    toApiModel(): EventApiModel {
        return {
            date: this.date.toDateString(),
            accountId: this.accountId,
            userId: this.userId,
            resourceId: this.resourceId,
            resourceType: this.resourceType,
            action: this.action,
            details: this.details,
        };
    }

    clone(): EventModel {
        const clone = new EventModel(this.toApiModel());

        return clone;
    }

    equals(other?: EventModel): boolean {
        if (!other) {
            return false;
        }

        if (this.date !== other.date) {
            return false;
        }

        if (this.accountId !== other.accountId) {
            return false;
        }

        if (this.userId !== other.userId) {
            return false;
        }

        if (this.resourceId !== other.resourceId) {
            return false;
        }

        if (this.resourceType !== other.resourceType) {
            return false;
        }

        if (this.action !== other.action) {
            return false;
        }

        if (this.details !== other.details) {
            return false;
        }
    }
}
